import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from "react-query";




const fetchProcessed = async (fileType) => {
    const headerConfig = setHeaders();
    const { data } = await axios
        .get(`${config.ENDPOINTS["datalake"]}/list/${fileType}`, {
            headers: headerConfig
        });

    return data;
};

export default function useFetchProcessed(fileType) {
    return useQuery(["processed", fileType], () => fetchProcessed(fileType), {

        onSuccess: (data) => {
            //console.log({ data });
        }
    });
}
